var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-404"},[_c('ErrorPage',{attrs:{"code":"404","desc":"对不起，您访问的页面不存在！"}},[_c('img',{attrs:{"slot":"img","src":require("../assets/image/404.jpg"),"alt":""},slot:"img"})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }